import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { LoginService } from "src/app/core/login/login.service";
import { AppraisalService } from "src/app/core/services/appraisal.service";
import { LearnerService } from "src/app/core/services/learner.service";
import { DocumentPreviewService } from "src/app/core/services/document-preview.service";
import { LoaderService } from "src/app/core/services/loader.service";
import { ESeparationService } from "src/app/core/services/e-separation.service"
import { PromotionHistoryComponent } from "../appraisal/promotion-history/promotion-history.component";
import { FormBuilder, FormGroup ,Validators,AbstractControl,ValidatorFn} from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ConfidentialityAcknowledgementComponent } from "../confidentiality-acknowledgement/confidentiality-acknowledgement.component";
import { SidebarService } from 'src/app/core/services/sidebar.service';


// Define the noLeadingZeroValidator function outside the component class
export function noLeadingZeroValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const value = control.value;
    if (value && value.startsWith('0')) {
      return { 'noLeadingZero': { value: control.value } };
    }
    return null;
  };
}
@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss']
})

export class ProfileComponent implements OnInit {
    user: any;
    lndUserType: any;
    name: any;
    emp: any;
    id: any;
    exitForm: FormGroup;
    finalLevel :any;
    steps: any;
    isTemp:any;
    currentStep:any;
    noticePeriod:any;
    day: any;
    month:any;
    lastWorkingDayYYYY:any;
    canSubmit:any;
    canWithdraw:any;
    msgApproval:string;
    exitId:number;
    type:string='document';
    documents: any = [];
    documentsFiles:any;
    removeFileName: any;
    withdrawalForm: FormGroup; 
    textareaText ="I have decided to resign from .....";
    emp_permissiions:any;
    isExitportal:boolean=false;
    confidentialityAcknowledged:boolean=false;
    sidebarCollapsed: boolean = false;
    // my position due to me relocating to other country for further studies.
    constructor(
        private learnerService: LearnerService,
        private documentPreview: DocumentPreviewService,
        private loginService: LoginService,
        private appraisalService: AppraisalService,
        public loaderService: LoaderService,
        private dialog: MatDialog,
        private fb: FormBuilder, 
        private eSeparationService: ESeparationService,
        private http: HttpClient,
        private msalService: LoginService,
        private sidebarService: SidebarService
    ) { }
    ngOnInit() {
      // Subscribe to sidebar collapsed state
      this.sidebarService.collapsed$.subscribe(collapsed => {
        this.sidebarCollapsed = collapsed;
      });

      // Show confidentiality acknowledgement dialog
      this.showConfidentialityDialog();
      
      this.withdrawalForm = this.fb.group({
        withdrawalReason: ['', Validators.required] // Reason is required
      });
        this.learnerService.getUserType().subscribe(res => {          
            this.user = res['lnd_user_type'];
            this.lndUserType = true;
            localStorage.setItem('user_type', res['lnd_user_type']);
        },
            (error: any) => {
                console.log(error, error.error, error.message);
                if (error.error == 'Signature has expired') {
                    this.loginService.logout();
                }
            });
        this.learnerService.getEmployeeDetails().subscribe((res: any) => {
            
          

     
      // <!-- code hide because  e-separation not going on Prod. start from  here -->

           let today = new Date();
            today.setDate(today.getDate() + res.data.notice_period_day);
            
            var day = today.getDate();
            var month = today.getMonth() + 1; 
            var year = today.getFullYear();
            
            
            if (day < 10) this.day = '0' + day;
            if (month < 10) this.month = '0' + month;
            
            
             let lastWorkingDay = `${day}-${month}-${year}`;
             this.lastWorkingDayYYYY = today.toISOString().split('T')[0]; 
            
            
            this.noticePeriod = lastWorkingDay
      // <!-- code hide because  e-separation not going on Prod. End  here -->
   
   
            this.emp = res.data;
            this.name = res.data.name;
            this.id = res.data.emp_id;
            this.emp_permissiions=res['employee_permissions'];
           this.isExitportal=this.emp_permissiions.exit_portal
            console.log(this.emp, "----------emp data")
        },
            (error: any) => {
                console.log(error, error.error, error.message);
                if (error.error == 'Signature has expired') {
                    this.loginService.logout();
                }
            })
        this.name = localStorage.getItem('name');
        this.exitForm = this.fb.group({
          exitReason: [this.textareaText, Validators.required], 
          whatsAppNumber: [
            '', 
            [
              Validators.required, // First validator
          Validators.pattern('^\\d{10}$'), // Second validator
          noLeadingZeroValidator() // Third validator (custom validator)
            ]
          ],
          personalEmail: [
            '', 
            [
              Validators.required, 
              Validators.email,
              Validators.pattern(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/) 
            ]
          ]
        });              
              // Sort steps by index
              this.learnerService.getDocumentsList(this.type).subscribe(res => {
                console.log(res);
                this.documents = res;
              },
                (error: any) => {
                  console.log(error, error.error, error.message);
                });
             





                this.eSeparationService.getCanSubmit().subscribe(
                    (res: any) => {
                      this.currentStep = res.data.final_level; // 1 to 6
                      this.canSubmit = res.data.can_submit;
                      this.canWithdraw = res.data.can_withdraw;
                      this.msgApproval = res.message;
                      this.exitId = res.data.exit_form_id;
                      this.steps = res.data.steps;
                      this.steps.sort((a, b) => a.index - b.index);
                      this.isTemp = res.data.is_temp
                      if(!this.canSubmit && !this.canWithdraw){
                        
                      
                         this.eSeparationService.getuploadedDocument(this.exitId).subscribe(
                        (res) => {
                          console.log(res);
                          this.documentsFiles = res;
                          const apiData = this.documentsFiles.data;
                          this.investmentDeclaration = apiData.investment_declare_form.file_category;
                          this.investmentDeclarationURL = apiData.investment_declare_form.file_url;
                          this.gratuityLeaveIncashment = apiData.gratuity.file_category;
                          this.gratuityLeaveIncashmentURL = apiData.gratuity.file_url;
                          this.interviewForm = apiData.interview_form.file_category;
                          this.interviewFormURL = apiData.interview_form.file_url;


                        },
                        (error: any) => {
                          console.log(error, error.error, error.message);
                        }
                      );
                    }
                    (error: any) => {
                             // Make the second API call after setting exitId
                          console.log(error, error.error, error.message);
                      if (error.error === 'Signature has expired') {
                        this.loginService.logout();
                      }
                    }
                  }
                  );




    }

    getPromotions() {
        this.appraisalService.getPromotionHistory({}).subscribe((res: any) => {
            console.log(res);
            let selfData = res.data;
            this.loaderService.setLoading(true);
            let dialogRef = this.dialog.open(PromotionHistoryComponent, {
                data: {
                    name: this.name,
                    emp_id: this.id,
                    data: selfData,
                },
            });
        },
            (error: any) => {
                console.log(error, error.error, error.message);
                if (error.error == 'Signature has expired') {
                    this.loginService.logout();
                }
            });
    }

    submitForm(): void {
        if (this.exitForm.valid) {
          const data = {            
          //  proposed_date: new Date().toISOString(),
            calculated_exit_date: this.lastWorkingDayYYYY,
            exit_reason: this.exitForm.value.exitReason,
            whatsapp_no: this.exitForm.value.whatsAppNumber,
            personal_email: this.exitForm.value.personalEmail,
            exit_type: 1
          };
         
          this.eSeparationService.submitExitForm(data).subscribe({
            next: (response: any) => {
                if (response && response.status === true) {
                    window.location.reload();
                } else {
                    // Handle successful HTTP calls but with status: false
                    alert(response.data || response.message || 'Request failed');
                }
            },
            error: (error) => {
                // The error is wrapped in a function, so we need to call it to get the actual HttpErrorResponse
                const actualError = typeof error === 'function' ? error() : error;
                
                if (actualError && actualError.error) {
                    const apiResponse = actualError.error;
                    
                    // Always show API message first, regardless of status code
                    if (apiResponse.message) {
                        alert(apiResponse.message);
                    } else if (apiResponse.data) {
                        alert(apiResponse.data);
                    } else {
                        // Only if no API message is available, show generic message
                        alert('An error occurred. Please try again.');
                    }
                } else {
                    // Network error or no API response
                    alert('Network error. Please check your connection and try again.');
                }
            }
          });
        }
      }
      showAlert(){
        alert(this.msgApproval)
      }




      // withdrawFunction(){
      //   this.eSeparationService.postWithdraw(this.exitId).subscribe({
      //     next: (response: any) => {
      //       console.log('Response:', response);
        
      //       if (response && response.status === true) {
      //           window.location.reload();
      //       } else {
      //         alert(response.message);
      //       }
      //     },
      //     error: (error) => console.error('Error:', error)
      //   });
      // } 


      submitWithdrawal(): void {
        if (this.withdrawalForm.invalid) {
          alert('Please provide a reason for withdrawal.');
          return;
        }
      
        const withdrawal_reason = this.withdrawalForm.value.withdrawalReason;
      
        // Call the updated postWithdraw method with the reason
        this.eSeparationService.postWithdraw(this.exitId, withdrawal_reason).subscribe({
          next: (response: any) => {
            console.log('Response:', response);
            if (response && response.status === true) {
              alert('Withdrawal request submitted successfully.');
              window.location.reload();
            } else {
              alert(response.message);
            }
          },
          error: (error) => {
            console.error('Error:', error);
            alert('An error occurred while submitting the withdrawal request.');
          }
        });
      
        // Close the modal
        const modal = document.getElementById('withdrawalReasonModal');
        if (modal) {
          modal.classList.remove('show');
          modal.setAttribute('aria-hidden', 'true');
          modal.setAttribute('style', 'display: none');
          const modalBackdrop = document.querySelector('.modal-backdrop');
          if (modalBackdrop) {
            modalBackdrop.remove();
          }
        }
      }
     
      
  


      investmentDeclaration: string | null = null;
      gratuityLeaveIncashment: string | null = null;
      interviewForm: string | null = null;
      investmentDeclarationURL: string | null = null;
      gratuityLeaveIncashmentURL: string | null = null;
      interviewFormURL: string | null = null;
      
      onFileSelected(
        event: Event, 
        fileNameProperty: 'investmentDeclaration' | 'gratuityLeaveIncashment' | 'interviewForm'
      ): void {
        const file = (event.target as HTMLInputElement).files?.[0];
        if (file) {
          const allowedExtensions = ['pdf', 'doc', 'docx'];
          const fileExtension = file.name.split('.').pop()?.toLowerCase();
      
          if (allowedExtensions.includes(fileExtension)) {
            this[fileNameProperty] = file.name; // Update the file name
            console.log(`Selected file for ${fileNameProperty}:`, file.name);
      
            const exitFormId = this.exitId;
            const formData = new FormData();
            formData.append('exit_form_id', exitFormId.toString()); // Append the exit_form_id
            formData.append(`${fileNameProperty}`, file, file.name); // Dynamically append the file with the form's name
      
            // Call the upload function with the formData
            this.exitDocumentsUpload(formData);
          } else {
            alert('Invalid file type. Only .pdf, .doc, and .docx files are allowed.');
            (event.target as HTMLInputElement).value = ''; // Reset the file input
            this[fileNameProperty] = null; // Clear the file name if invalid
          }
        } else {
          this[fileNameProperty] = null; // Clear the file name if no file is selected
        }
      }
      




      
      
      removeFile(fileName: string): void {
        if (fileName === 'investmentDeclaration') {
          this.investmentDeclaration = null;  // Clear the investmentDeclaration
        } else if (fileName === 'gratuityLeaveIncashment') {
          this.gratuityLeaveIncashment = null;  // Clear the gratuityLeaveIncashment
        } else if (fileName === 'interviewForm') {
          this.interviewForm = null;  // Clear the interviewForm
        }
      }

      


      getDocumentFile(title: string): string | null {
        const document = this.documents.find((item: any) => item.title === title);
        return document ? document.file : null;
      }

      viewDownloadPdf(file:string) {
        if (!file) {
          return;
        }

        this.documentPreview.preview(file, undefined, 'Profile');
      }


    exitDocumentsUpload(payload){
      this.eSeparationService.postExitDocumentsUpload(payload).subscribe({
        next: (response: any) => {
          console.log('Response:', response);
          if (response && response.status === true && response.status === 200) {
            window.location.reload();
          } else {

            window.location.reload();
            alert(response.message);
          }
        },
        error: (error) => console.error('Error:', error)
      });
    }




      isLoggedIn(): boolean {
    return this.msalService.isLoggedIn();
  }

      showConfidentialityDialog(): void {
        const acknowledged = sessionStorage.getItem('confidentialityAcknowledged');
        if (acknowledged === 'true') {
          this.confidentialityAcknowledged = true;
          return;
        }

        // Show the confidentiality dialog
        const dialogRef = this.dialog.open(ConfidentialityAcknowledgementComponent, {
          width: '800px',
          panelClass: 'confidentiality-dialog-panel',
          disableClose: true // Prevent closing by clicking outside
        });

        dialogRef.afterClosed().subscribe(result => {
          // result is true when user clicks OK
          this.confidentialityAcknowledged = !!result;
        });
      }

    }


